import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DialogService, DialogType } from "../services/dialog.service";

@Component({
  selector: "app-dialog",
  templateUrl: "./dialog.component.html",
  styleUrls: ["./dialog.component.scss"],
})
export class DialogComponent implements OnInit, OnDestroy {
  dialogConfig;
  btnConfig;
  show: boolean = false;
  zIndex?: number = 1000;
  private btnMapper = {
    [DialogType.Delete]: () => this.setDeleteBtns(),
    [DialogType.Continue]: () => this.setContinueBtns(),
    [DialogType.YesNo]: () => this.setYesNoBtns(),
  };

  constructor(private dialogService: DialogService) {}
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  ngOnInit() {
    this.dialogService
      .registerDialog()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (config: {
          headerText: string;
          detailText: string;
          dialogType: DialogType;
          warningText?: string;
          fullscreen?: boolean;
          zIndex?: number;
        }) => {
          this.dialogConfig = config;
          this.btnMapper[config.dialogType]();
          this.show = true;
          if (config.zIndex) this.zIndex = config.zIndex;
        }
      );
  }

  onFeedback(feedback: boolean) {
    this.dialogService.dialogFeedback(feedback);
    this.show = false;
  }

  private setDeleteBtns() {
    this.btnConfig = {
      class: "deleteBtn",
      text: "Yes, delete",
      cancel: "Cancel",
      img: "assets/Delete_round.svg",
    };
  }

  private setContinueBtns() {
    this.btnConfig = {
      class: "continueBtn",
      text: "Yes, Continue",
      cancel: "Cancel",
      img: "assets/Keen&Wise_save.png",
    };
  }

  private setYesNoBtns() {
    this.btnConfig = {
      class: "continueBtn",
      text: "Yes",
      cancel: "No",
      img: "assets/Keen&Wise_save.png",
    };
  }
}
